
import { defineComponent } from 'vue'
import useLesson from '@web/composition/useLesson'

export default defineComponent({
  props: {
    lesson: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['click'],
  setup () {
    return {
      time: useLesson().time
    }
  }
})
